export const CONTACT_PHONE_NUMBER_DISPLAY = "03 29 34 60 85";
export const CONTACT_PHONE_NUMBER = "+33329346085";
export const CONTACT_EMAIL = "secretariat@cslouisemichel.fr";
